import React from "react"

import { GatsbyImage } from "gatsby-plugin-image";
import Content from "../../particles/Content"
import StyledFooter from "./Footer.style"
import { Link } from "gatsby"
import { useFooterData } from "../../particles/hooks/useFooterData"
import he from 'he'
import { randomID } from "../../particles/helpers"

const Footer = ({ style }) => {

  let footerData = useFooterData()

  return (
    <StyledFooter style={style}>
      <section className="association-logos">
        <Content>
          <a href={he.decode(footerData[0].title)} target="_blank" rel="nofollow">
            <GatsbyImage
              alt={footerData[0].altText}
              image={footerData[0].localFile.childImageSharp.gatsbyImageData}
              style={{ maxHeight: "200px", gridColumn: "1/6", marginBottom: '5rem' }}
              objectFit="contain" />
          </a>
          <section className="logos">
            {footerData.slice(1).map(logo => {
              return (
                <a
                  href={he.decode(logo.title)}
                  target="_blank"
                  rel="nofollow"
                  key={randomID()}
                  style={{
                    maxHeight: "120px",
                    maxWidth: "120px",
                    display: "inline-block",
                  }}
                >
                  <GatsbyImage
                    alt={logo.altText}
                    image={logo.localFile.childImageSharp.gatsbyImageData}
                    objectFit="contain"
                    style={{
                      maxHeight: "120px",
                      maxWidth: "120px",
                    }} />
                </a>
              );
            })}
          </section>
        </Content>
      </section>
      <Content>
        <p style={{ fontSize: "2rem", textTransform: "uppercase" }}>
          &copy; {new Date().getFullYear()} Dixie Plywood and Lumber Company |
          All Rights Reserved | <Link to="/privacy-policy">Privacy Policy</Link> | <Link to="/terms">Terms &amp; Conditions</Link> | <Link to="http://transparency-in-coverage.uhc.com/">Health Care MRF</Link>
          <br />
          Website provided by{" "}
          <a href="https://buildingonline.com" target="_blank" rel="nofollow">
            BuildingOnline
          </a>
        </p>
      </Content>
    </StyledFooter>
  );
}

export default Footer
